import { render, staticRenderFns } from "./EditPreOrder.vue?vue&type=template&id=b877bdf6"
import script from "./EditPreOrder.vue?vue&type=script&lang=js"
export * from "./EditPreOrder.vue?vue&type=script&lang=js"
import style0 from "./EditPreOrder.vue?vue&type=style&index=0&id=b877bdf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports